import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit'
import { userCircle } from 'react-icons-kit/fa/userCircle'
import { ic_exit_to_app } from 'react-icons-kit/md/ic_exit_to_app'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { colors } from '../../utils/vars'
import DefineTema from '../DefineTema'

import './index.css';

const swal = withReactContent(Swal)

function UserOptions(props) {
    const [auth, setAuth] = useState(JSON.parse(localStorage['authsalute'] || JSON.stringify({ authenticated: false, user: 0 })));

    useEffect(() => {
        if (auth) {


        }
    }, [auth])
    function trocaTema(e, propriedades) {
        e.preventDefault()
        let obj = JSON.parse(localStorage['authsalute'])
        if (obj.temaEscuro) {
            obj.temaEscuro = false
        } else {
            obj.temaEscuro = true
        }
        localStorage['authsalute'] = JSON.stringify(obj)
        setAuth(obj)
        props.setTemaEscuro(obj.temaEscuro)
    }

    function logout(e) {
        e.preventDefault();
        swal.fire({
            title: 'Deseja sair do sistema?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: colors.success500,
            cancelButtonColor: colors.danger500,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                localStorage['authsalute'] = JSON.stringify({ authenticated: false, user: 0 })
                window.location.href = '/salute/login'
            }
        })

    }

    return (
        <div className="userOptions">
            <DefineTema temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
            <Icon icon={userCircle} size={24} style={{ marginRight: '5px', marginLeft: '5px' }} />
            <div className="userName">{auth.name}</div>
            <button onClick={logout}>
                <Icon icon={ic_exit_to_app} size={24} />
            </button>
        </div>
    );
}

export default UserOptions;